import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '../../../infra/i18n';
import styles from './styles.module.scss';
export var EmptyWalkInList = function (_a) {
    var activeView = _a.activeView;
    return (_jsx("div", { className: styles['empty-list'], children: activeView === 'current'
            ? t('appointment:walk_in_list.empty.no_clients_today')
            : t('appointment:walk_in_list.empty.no_clients_selected_day') }));
};
